import Immutable from 'immutable';
import { createSelectorCreator, defaultMemoize } from 'reselect';
export const createImmutableSelector = createSelectorCreator(defaultMemoize, Immutable.is);
export const createImmutableSliceSelector = sliceName => createImmutableSelector([state => state[sliceName]], slice => slice);